import React from "react";
import Helmet from "react-helmet";
import Header from "../organisms/Header";
import Footer from "../organisms/Footer";
import BlogPost from "../molecules/BlogPost";

import "../sass/main.scss";

const TemplateWrapper = ({ data }) => {
  const post = data.markdownRemark;
  return (
    <div className="container">
      <Helmet
        title={"a post"}
        meta={[{ name: "twitter:title", content: "a post" }]}
      />
      <BlogPost
        title={post.frontmatter.title}
        author={post.frontmatter.author}
        date={post.frontmatter.date}
        excerpt={post.excerpt}
        socialImage={post.frontmatter.socialImage}
      >
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
      </BlogPost>
    </div>
  );
};

export default TemplateWrapper;

export const query = graphql`
  query BlogPostQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        author
        date
        socialImage
      }
      excerpt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js